import { sessionGet, SessionKeys } from 'utils/tokenStorage';
import { getMamiClient } from 'clients/mami';
import { TrackEventPayloadDTO } from '@peartherapeutics/mami-client';
import { v4 as uuidv4 } from 'uuid';

export const generateRequiredProperties = () => ({
  client: 'web',
  actorContext: 'Staff',
  eventVersion: 2,
  eventTime: +new Date(),
  sessionId: sessionGet(SessionKeys.SESSION_ID) || uuidv4(),
  userAgent: window.navigator.userAgent,
});

export const trackEventAsync = async (
  eventObject: TrackEventPayloadDTO,
): Promise<void> => {
  const api = await getMamiClient();
  await api.v2TrackPost(eventObject);
};
